import { ButtonGroup, ButtonText, Dialog, DialogCardBody, DialogCardFooter, DialogCardHead, DialogCardHeadIcon, DialogCardHeadTitle, Grid, Icon, Typography } from "@visa/vds";
import React from "react";

const CertificationPackageDialog = ({
    dialogType = null,
    open, setOpen,
    title,
    leftButton, rightButton,
    children
}) => {
    return (
        <>
            <Dialog
                aria-describedby={title}
                onExit={() => setOpen(false)}
                open={open}
                type={dialogType}
                titleId="dialog-certification-package"
            >
                <DialogCardHead>
                    <DialogCardHeadIcon>{dialogType && <Icon name={dialogType} resolution="low" />}</DialogCardHeadIcon>
                    <DialogCardHeadTitle id="dialog-certification-package-title">{title}</DialogCardHeadTitle>
                </DialogCardHead>
                <DialogCardBody id="dialog-certification-package-title-body">
                    <Grid>{children}</Grid>
                </DialogCardBody>
                <DialogCardFooter>
                    <ButtonGroup direction="right">
                        {leftButton &&
                            <ButtonText colorScheme={leftButton.color} onClick={() => {
                                leftButton.handleClick && leftButton.handleClick()
                                leftButton.remainOpen ?? setOpen(false)
                            }}>
                                {leftButton.text}
                            </ButtonText>
                        }
                        {rightButton &&
                            <ButtonText colorScheme={rightButton.color} onClick={() => {
                                rightButton.handleClick && rightButton.handleClick()
                                rightButton.remainOpen ?? setOpen(false)
                            }}>
                                {rightButton.text}
                            </ButtonText>
                        }
                    </ButtonGroup>
                </DialogCardFooter>
            </Dialog>
        </>
    )
}

export default CertificationPackageDialog;